// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import draggable from "vuedraggable";

Vue.config.productionTip = false;

function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

/* eslint-disable no-new */
var app = new Vue({
  el: "#app",
  components: {
    draggable
  },
  data: {
    playing: true,
    message: "Hello!",
    dragOptions: {
      disabled: false
    },
    totalscore: 0,
    lists: [],
    lists_sorted: []
  },
  methods: {
    init: function() {
      var rawq = `テレホーダイ 開始,19950822,https://ja.wikipedia.org/wiki/%E3%83%86%E3%83%AC%E3%83%9B%E3%83%BC%E3%83%80%E3%82%A4
ウルトラマンPC（Palm Top PC 110）国内発売,19951025,https://ja.wikipedia.org/wiki/Palm_Top_PC_110
Windows 95 国内発売,19951123,https://ja.wikipedia.org/wiki/Microsoft_Windows_95
ピピンアットマーク 国内発売,19960328,https://ja.wikipedia.org/wiki/%E3%83%94%E3%83%94%E3%83%B3%E3%82%A2%E3%83%83%E3%83%88%E3%83%9E%E3%83%BC%E3%82%AF
「セガは倒れたままなのか」,19980521,https://ja.wikipedia.org/wiki/%E3%83%89%E3%83%AA%E3%83%BC%E3%83%A0%E3%82%AD%E3%83%A3%E3%82%B9%E3%83%88
セガ ドリームキャスト 国内発売,19981127,https://ja.wikipedia.org/wiki/%E3%83%89%E3%83%AA%E3%83%BC%E3%83%A0%E3%82%AD%E3%83%A3%E3%82%B9%E3%83%88
ワンダースワン 発売,19990304,https://ja.wikipedia.org/wiki/%E3%83%AF%E3%83%B3%E3%83%80%E3%83%BC%E3%82%B9%E3%83%AF%E3%83%B3
初代AIBO（ERS-110）発売,19990601,https://ja.wikipedia.org/wiki/AIBO
ソーテック e-one 発売,19990720,https://pc.watch.impress.co.jp/docs/article/990730/eone.htm
シーマン 発売,19990729,https://ja.wikipedia.org/wiki/%E3%82%B7%E3%83%BC%E3%83%9E%E3%83%B3
ネットランナー創刊,19990929,https://ja.wikipedia.org/wiki/%E3%83%8D%E3%83%88%E3%83%A9%E3%83%B3
Morphy One 開発発表,19991101,https://www.watch.impress.co.jp/mobile/news/1999/11/01/morphy.htm
カメラ付きケータイ J-SH04 発表,20000926,https://ja.wikipedia.org/wiki/J-SH04
DDI/KDD/IDOが合併、通称KDDIが発足,20001001,https://ja.wikipedia.org/wiki/KDDI#%E6%A6%82%E8%A6%81
Diablo II 日本語版発売,20001018,https://ja.wikipedia.org/wiki/%E3%83%87%E3%82%A3%E3%82%A2%E3%83%96%E3%83%AD2
Amazon.co.jp オープン,20001101,https://www.amazon.co.jp/gp/press/pr/20001101/
楽天がインフォシークを買収,20001130,https://internet.watch.impress.co.jp/www/article/2000/1130/info.htm
花柄iMac（Flower Power）国内発売,20010224,https://pc.watch.impress.co.jp/docs/article/20010222/apple1.htm
侍魂が先行者を取り上げる,20010303,https://ja.wikipedia.org/wiki/%E5%85%88%E8%A1%8C%E8%80%85
1ch.tv 正式開始,20011005,https://ja.wikipedia.org/wiki/1ch.tv
Xbox（初代）国内発売,20020222,https://ja.wikipedia.org/wiki/Xbox
「mesh抜きでは日本におけるblog草創期を語れない」,20021023,http://bloggers.ja.bz/myojin/archives/000002.html
「日本人にはブログより日記」,20030411,https://japan.cnet.com/article/20053530/
Second Life 正式公開,20030623,https://ja.wikipedia.org/wiki/Second_Life
J-PHONEがブランド・会社名をVodafoneへ変更,20031001,https://ja.wikipedia.org/wiki/SoftBank_(%E6%90%BA%E5%B8%AF%E9%9B%BB%E8%A9%B1)#%E3%83%9C%E3%83%BC%E3%83%80%E3%83%95%E3%82%A9%E3%83%B3
初代ガングリップ型Xacti（DMX-C1）発売,20031107,https://pc.watch.impress.co.jp/docs/2003/1001/sanyo.htm
Yahoo BB! 個人情報漏洩を受けて金券500円提供,20040227,https://internet.watch.impress.co.jp/cda/news/2004/02/27/2252.html
電車男 書き込みがはじまる,20040314,https://ja.wikipedia.org/wiki/%E9%9B%BB%E8%BB%8A%E7%94%B7
Gmail ベータ版開始,20040401,https://ja.wikipedia.org/wiki/Gmail
Winny 製作者逮捕,20040509,https://ja.wikipedia.org/wiki/Winny%E4%BA%8B%E4%BB%B6
AH-K3001V（京ぽん）発売,20040514,https://ja.wikipedia.org/wiki/AH-K3001V
Google NASDAQに上場,20040819,https://ja.wikipedia.org/wiki/Google
Mozilla Firefox 1.0 リリース,20041109,https://ja.wikipedia.org/wiki/Mozilla_Firefox%E3%81%AE%E3%83%90%E3%83%BC%E3%82%B8%E3%83%A7%E3%83%B3%E3%81%AE%E5%A4%89%E9%81%B7#Firefox_1.0
Half-Life 2 発売,20041117,https://ja.wikipedia.org/wiki/%E3%83%8F%E3%83%BC%E3%83%95%E3%83%A9%E3%82%A4%E3%83%952
IBM、PC事業のレノボへの売却を発表,20041208,https://ja.wikipedia.org/wiki/ThinkPad
「神、いわゆるゴッド」,20050118,http://d.hatena.ne.jp/keyword/%BF%C0%A1%A2%A4%A4%A4%EF%A4%E6%A4%EB%A5%B4%A5%C3%A5%C9
DDIポケット ウィルコムに改称,20050202,https://ja.wikipedia.org/wiki/%E3%82%A6%E3%82%A3%E3%83%AB%E3%82%B3%E3%83%A0
はてなブックマーク 公開,20050210,http://www.itmedia.co.jp/news/articles/0502/10/news121.html
YouTube 初の動画が投稿,20050423,https://ja.wikipedia.org/wiki/YouTube
(c)のまネコ製作委員会 表記が問題化,20050901,http://www.itmedia.co.jp/news/articles/0509/09/news088.html
ジョブズがポケットからiPad nanoを取り出す,20050907,https://ja.wikipedia.org/wiki/IPod_nano
ジェイコム株大量誤発注事件,20051208,https://ja.wikipedia.org/wiki/%E3%82%B8%E3%82%A7%E3%82%A4%E3%82%B3%E3%83%A0%E6%A0%AA%E5%A4%A7%E9%87%8F%E8%AA%A4%E7%99%BA%E6%B3%A8%E4%BA%8B%E4%BB%B6
ライブドア本社に強制捜査,20060116,https://ja.wikipedia.org/wiki/%E3%83%A9%E3%82%A4%E3%83%96%E3%83%89%E3%82%A2%E3%83%BB%E3%82%B7%E3%83%A7%E3%83%83%E3%82%AF
はてなわんわんワールド 開始,20060225,http://hatena.g.hatena.ne.jp/hatelabo/20060225/1140877027
iPod Hi-Fi 国内発表,20060301,https://www.apple.com/jp/newsroom/2006/03/28Apple-Announces-iPod-Hi-Fi/
「Welcome to Underground」,20060814,https://moto-neta.com/net/welcome-to-underground/
恋空 書籍化,20061007,https://ja.wikipedia.org/wiki/%E6%81%8B%E7%A9%BA
GoogleがYouTubeの買収に合意,20061009,https://ja.wikipedia.org/wiki/YouTube
MNP 開始,20061024,https://ja.wikipedia.org/wiki/%E7%95%AA%E5%8F%B7%E3%83%9D%E3%83%BC%E3%82%BF%E3%83%93%E3%83%AA%E3%83%86%E3%82%A3
「物売るってレベルじゃねーぞ」,20061111,http://dic.nicovideo.jp/a/%E7%89%A9%E5%A3%B2%E3%82%8B%E3%81%A3%E3%81%A6%E3%81%84%E3%81%86%E3%83%AC%E3%83%99%E3%83%AB%E3%81%98%E3%82%83%E3%81%AD%E3%81%87%E3%81%9E%21
任天堂 Wii 国内発売,20061202,https://ja.wikipedia.org/wiki/Wii
ニコニコ動画（仮）開始,20061212,https://ja.wikipedia.org/wiki/%E3%83%8B%E3%82%B3%E3%83%8B%E3%82%B3%E5%8B%95%E7%94%BB
Tumblr サービス開始,20070301,https://ja.wikipedia.org/wiki/Tumblr
「そろそろ反撃してもいいですか？」ドコモ発表会,20070423,https://ja.wikipedia.org/wiki/DoCoMo2.0
「モスバーガーのきれいな食い方教えれ」,20070927,http://chaos2ch.com/archives/1311275.html
ジョブズが茶封筒からMacbook Airを取り出す,20080115,https://ja.wikipedia.org/wiki/MacBook_Air
「乗るしかない　このビッグウェーブに」,20080711,http://dic.nicovideo.jp/a/butch%E3%81%95%E3%82%93
「あなたとは違うんです」,20080901,http://dic.nicovideo.jp/a/%E3%81%82%E3%81%AA%E3%81%9F%E3%81%A8%E3%81%AF%E9%81%95%E3%81%86%E3%82%93%E3%81%A7%E3%81%99
初代ポメラ（DM-10）発売,20081110,https://ja.wikipedia.org/wiki/%E3%83%9D%E3%83%A1%E3%83%A9
アメーバピグ 開始,20090219,https://ja.wikipedia.org/wiki/%E3%82%A2%E3%83%A1%E3%83%BC%E3%83%90%E3%83%94%E3%82%B0
Google Wave 発表,20090527,https://en.wikipedia.org/wiki/Apache_Wave
iPhone 3GS 国内発売,20090626,https://ja.wikipedia.org/wiki/IPhone_3GS
日本初のAndroidスマートフォン HT-03A 発売,20090710,https://ja.wikipedia.org/wiki/HTC_Magic#HT-03A
「初カキコ…ども… 」,20091203,http://dic.nicovideo.jp/a/%E5%88%9D%E3%82%AB%E3%82%AD%E3%82%B3...%E3%81%A9%E3%82%82...
日本語版Twitterに公式リツイート機能,20100122,https://ja.wikipedia.org/wiki/Twitter
Google Buzz 開始,20100210,https://ja.wikipedia.org/wiki/Google_Buzz
サンシャイン牧場 エイプリルフールで山火事,20100401,https://ja.wikipedia.org/wiki/%E3%82%B5%E3%83%B3%E3%82%B7%E3%83%A3%E3%82%A4%E3%83%B3%E7%89%A7%E5%A0%B4_(%E3%82%B2%E3%83%BC%E3%83%A0)
mixi 会員が2000万人を突破,20100414,https://internet.watch.impress.co.jp/docs/news/361148.html
iPad 国内発売,20100528,https://ja.wikipedia.org/wiki/IPad_(%E7%AC%AC1%E4%B8%96%E4%BB%A3)
「どん判」「金ドブ」,20100802,https://ja.wikipedia.org/wiki/%E7%A8%B2%E8%88%B9%E6%95%AC%E4%BA%8C
バードカフェ、グルーポンおせち問題で謝罪,20110102,https://ameblo.jp/gaishokubunka/entry-10755867555.html
パナソニックが三洋電機を完全子会社化,20110401,https://ja.wikipedia.org/wiki/%E4%B8%89%E6%B4%8B%E9%9B%BB%E6%A9%9F
mixi 足あと機能を廃止,20110613,https://japan.cnet.com/article/35003630/
LINE サービス開始,20110623,https://ja.wikipedia.org/wiki/LINE_(%E3%82%A2%E3%83%97%E3%83%AA%E3%82%B1%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3)
カレログ 公開,20110829,https://ja.wikipedia.org/wiki/%E3%82%AB%E3%83%AC%E3%83%AD%E3%82%B0
Kindle端末 日本発売,20111119,http://bizmakoto.jp/makoto/articles/1210/24/news126.html
「私は学長です」,20120219,https://togetter.com/li/260513
Oculus DK1 Kickstarter開始,20120801,https://en.wikipedia.org/wiki/Oculus_Rift
Vine サービス開始,20130124,https://ja.wikipedia.org/wiki/Vine_(%E3%82%A2%E3%83%97%E3%83%AA%E3%82%B1%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3)
ハフィントン・ポスト日本版 開設,20130507,https://ja.wikipedia.org/wiki/%E3%83%8F%E3%83%95%E3%83%9D%E3%82%B9%E3%83%88
ドコモ ツートップを発表,20130515,http://www.itmedia.co.jp/news/articles/1305/15/news129.html
Google Reader 終了,20130701,https://ja.wikipedia.org/wiki/Google%E3%83%AA%E3%83%BC%E3%83%80%E3%83%BC
メルカリ サービス開始,20130702,http://thebridge.jp/2013/07/shintaro-yamada-revealed-new-project-mercari-at-kouzou
「保育園落ちた日本死ね！！！」,20160215,https://anond.hatelabo.jp/20160215171759`;
      var rawqlists = rawq.split(/\n|\r/g);
      rawqlists = shuffle(rawqlists);
      for (var i = 0; i < 10; i++) {
        var q = {};
        q.id = i;
        q.score = 0;
        var rawqdata = rawqlists[i].split(/,/);
        q.text = rawqdata[0];
        q.date = rawqdata[1];
        q.link = rawqdata[2];
        q.date_format =
          rawqdata[1].substr(0, 4) +
          "年" +
          Math.round(rawqdata[1].substr(4, 2)) +
          "月" +
          Math.round(rawqdata[1].substr(6, 2)) +
          "日";
        app.lists.push(q);
        app.lists_sorted.push(q);
      }
      //      sorted_id = ;
      app.lists_sorted.sort((a, b) =>
        a.date > b.date ? 1 : b.date > a.date ? -1 : 0
      );

      for (var i = 0; i < 10; i++) {
        app.lists[app.lists_sorted[i].id].rank = i;
      }

      document.getElementById("contents").style.display = "block";
      document.getElementById("loading").style.display = "none";
    },
    onEnd: function(originalEvent) {
      //originalEventは イベントを取得できる
    },
    rankUp: function(rank) {
      var now = app.lists[rank].id;
      app.lists[rank].id = app.lists[rank - 1].id;
      app.lists[rank - 1].id = now;
      app.lists[rank].number = rank;
      app.lists[rank - 1].number = rank - 1;
    },
    rankDown: function(rank) {
      var now = app.lists[rank].id;
      app.lists[rank].id = app.lists[rank + 1].id;
      app.lists[rank + 1].id = now;
      app.lists[rank].number = rank;
      app.lists[rank + 1].number = rank + 1;
    },

    evaluate: function(rank) {
      var buttons = document.getElementsByClassName("button");
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].style.display = "none";
      }

      app.dragOptions["disabled"] = true;
      app.playing = false;
      app.totalscore = 0;
      for (var i = 0; i < 10; i++) {
        var listscore = Math.abs(i - app.lists[i].rank);
        app.lists[i].score = 10 - listscore;
        app.totalscore += app.lists[i].score;
      }
    },

    replay: function(rank) {
      document.getElementById("contents").style.display = "none";
      document.getElementById("loading").style.display = "block";
      app.dragOptions["disabled"] = false;
      app.playing = true;
      app.lists = [];
      app.lists_sorted = [];
      app.init();
    }
  }
});
app.init();
//app.qs = app.original_qs;



// WEBPACK FOOTER //
// ./src/main.js